import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import useScript from 'react-script-hook';
import { appConfig } from '../../common/app.config';
import useSWR, { mutate } from 'swr';
import { fetcher } from '../../common/api/fetcher';
import ErrorBox, { noError } from '../../common/components/ErrorBox';
import { LoadingSpinner } from '../../common/components/LoadingSpinner';
import { PlaceEditForm } from '../components/PlaceEditForm';
import { placeToSiteFormValues } from '../../places/api/sites.dto';
import { approvePlaceEdit, denyPlaceEdit } from '../api/edits.api';
import { PageFrame } from '../../common/components/PageFrame';

export const ViewPlaceEditPage = () => {
  const history = useHistory();
  const { id: placeEditId } = useParams();
  const [placeEdit, setPlaceEdit] = useState(false);
  const [scriptLoading] = useScript({
    src: `https://maps.googleapis.com/maps/api/js?key=${appConfig.googleMaps.apiKey}&libraries=places`,
    checkForExisting: true,
  });
  const { data, error } = useSWR(
    !scriptLoading ? `/portal/edits/places/${placeEditId}` : null,
    fetcher
  );
  const [errorBox, setErrorBox] = useState(noError);
  const [loadingValue, setLoadingValue] = useState(null);

  useEffect(() => {
    if (error) {
      setErrorBox({
        title: 'Error loading brand',
        msg: 'Please try again',
      });
    }
  }, [error]);

  useEffect(() => {
    const run = async () => {
      const _placeEdit = await placeToSiteFormValues(data);
      setPlaceEdit(_placeEdit);
    };
    if (data) {
      run();
    }
  }, [data]);

  const handleApprove = async () => {
    setLoadingValue('approve');
    await approvePlaceEdit(placeEditId);
    await mutate(`/portal/edits/places`);
    await mutate(`/portal/edits`);
    history.push('/edits/list');
  };

  const handleDeny = async () => {
    setLoadingValue('approve');
    await denyPlaceEdit(placeEditId);
    await mutate(`/portal/edits/places`);
    await mutate(`/portal/edits`);
    history.push('/edits/list');
  };

  return (
    <PageFrame title="View Suggested Place">
      {!placeEdit && <LoadingSpinner />}
      {placeEdit && (
        <PlaceEditForm
          onApprove={handleApprove}
          onDeny={handleDeny}
          value={placeEdit}
          loadingValue={loadingValue}
        />
      )}
      <ErrorBox
        title={errorBox.title}
        msg={errorBox.msg}
        onClose={() => setErrorBox(noError)}
      />
    </PageFrame>
  );
};
